import { tableSchema } from '@nozbe/watermelondb'

export const cropSchema = tableSchema({
  name: 'crop',
  columns: [
    { name: 'cropId', type: 'string' },
    { name: 'description', type: 'string' },
    { name: 'internalCode', type: 'number' },
    { name: 'slug', type: 'string' },
    { name: 'extraAttributes', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'updatedAt', type: 'string' }
  ]
})